import script from "./Sula-Webshop-Stock.vue?vue&type=script&setup=true&lang=js"
export * from "./Sula-Webshop-Stock.vue?vue&type=script&setup=true&lang=js"

import "./Sula-Webshop-Stock.vue?vue&type=style&index=0&id=2779d8fe&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2779d8fe"]])

export default __exports__